export default __webpack_public_path__ + "static/european_chic-2c00bc988daf268e7f1532df9222aa9b.png";